export class UTC{
  zonde_id:string;
  utc_format:string;
  utc_miliseconds:number;
}
